/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Extended_Ad_LabelInputs */



/**
* | output |
* | --- |
* | "Extended AD" |
*
* @param {Audio_Description_Export_Extended_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_extended_ad_label = /** @type {((inputs?: Audio_Description_Export_Extended_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Extended_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AD étendue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erweiterte Werbung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annuncio esteso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширенная AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("AD extendido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扩展广告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡張AD")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विस्तारित विज्ञापन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AD estendido")
	return /** @type {LocalizedString} */ ("Extended AD")
});